module.exports = __webpack_public_path__ + "static/media/txt.a1a51031.png";